export default "<span class=\"button-container\" (click)=\"doDelete()\">\r\n    <i class=\"pplus-icon-trash\"></i>\r\n</span>\r\n"